export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$eventBus', { value: new Vue() });
  },
};
